// test2670
(2670 && 0);
